

export const UseUrlSSL = "https://8.138.236.69:8089";
export const UseUrl = "/api"
